import { useUser } from "@clerk/clerk-expo";
import Container from "components/general/Container";
import PageLoader from "components/general/PageLoader";
import ScrollContainer from "components/general/ScrollContainer";
import Seo from "components/general/Seo";
import TreeGroupNode from "components/navigation/TreeGroupNode";
import { Box, Button, H2, ParagraphSmall, Text, VStack } from "components/ui";
import { FilePenLine, FlagTriangleRight } from "lucide-react-native";
import React from "react";
import { useGetGroupQuery } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
export default function Page() {
	const [pageNumber, setPageNumber] = React.useState(1);
	const { data, isLoading, isFetching } = useGetGroupQuery({});
	const isMobile = useIsMobile();
	const { user } = useUser();
	const companyCollection: any = user?.publicMetadata?.companyData;
	let currentCompanyName = companyCollection[user?.unsafeMetadata?.companyId as string]?.name;
	if (isLoading || data == null) {
		return (
			<Box minHeight={50}>
				<PageLoader />
			</Box>
		);
	}
	if (isMobile) {
		return (
			<ScrollContainer>
				<Container sx={{ height: "100%" }}>
					<Box mx={12}>
						<TreeGroupNode rootNodeName={currentCompanyName} isFluid basicNode={data} level={0} defaultOpen={true} />
					</Box>
				</Container>
			</ScrollContainer>
		);
	}
	return (
		<Box>
			<Seo title="Admin | Groups | Abconet" description="Create and manage user groups to control permissions and access." />
			<Box borderRadius={12} py={80} px={24} justifyContent="center" alignItems="center" bg="$lighttealxlight" width={"$full"}>
				<VStack mb={24} gap={8} alignItems="center">
					<Box borderRadius={40} mb={16} padding={44} bg="$primarylightblue">
						<FilePenLine color="white" width={60} height={60} />
					</Box>
					<H2>Select a site or group</H2>
					<Text fontSize={18} style={{ fontFamily: "Roboto_400Regular" }}>
						View, edit, add and delete
					</Text>
				</VStack>
				{/* <VStack gap={12} alignItems="center" justifyContent="center">
					<Button variant="outline" gap={12} borderColor="$basicblack">
						<FlagTriangleRight width={20} height={20} />
						<ParagraphSmall>View the tour</ParagraphSmall>
					</Button>
					<ParagraphSmall weight="normal">Take the 20 second tour</ParagraphSmall>
				</VStack> */}
			</Box>
		</Box>
	);
}
